/* eslint-disable */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Tab from './Tab';
import './Tabs.css';
class Tabs extends Component {
  static propTypes = {
    children: PropTypes.instanceOf(Array).isRequired,
    buyerCount: PropTypes.number,
    sellerCount: PropTypes.number,
  };

  constructor(props) {
    super(props);
    const initialActive = this.props.defaultActive
      ? this.props.defaultActive
      : this.props.children[0].props.label;

    this.state = {
      activeTab: initialActive,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.defaultActive !== this.props.defaultActive && this.props.defaultActive) {
      this.setState({ activeTab: this.props.defaultActive });
    }
  }

  onClickTabItem = (tab) => {
    this.setState({ activeTab: tab });
    this.props.callback_tabclick(tab);
  };

  render() {
    const {
      onClickTabItem,
      props: { children },
      state: { activeTab },
    } = this;

    return (
      <div className='tabs'>
        <ol className='tab-list mb-0'>
          {children.map((child, idx) => {
            const { label } = child.props;
            const key = typeof label === 'string' ? label : idx;

            return (
              <Tab
                activeTab={activeTab}
                key={key}
                label={label}
                onClick={onClickTabItem}
                buyerCount={this.props.buyerCount}
                sellerCount={this.props.sellerCount}
              />
            );
          })}
        </ol>
        <div className={'tab-content ' + (this.props.border_r === true ? 'border-right' : '')}>
          {children.map((child) => {
            if (child.props.label !== activeTab) return undefined;
            return child.props.children;
          })}
        </div>
      </div>
    );
  }
}

Tabs.propTypes = {
  callback_tabclick: PropTypes.func,
};

export default Tabs;
